// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Install.css */
/* Базові стилі для світлої теми (дефолтні) */
.app-container {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100vh;
}

/* Стилі для темної теми - ТІЛЬКИ ФОН */
.App.dark-theme .app-container {
  background-color: #1a202c; /* Змінено з #121212 на #1a202c */
}

.App.dark-theme .pool-section {
  background-color: #414752; /* Змінено з #1e1e1e на #414752 */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.App.dark-theme .pool-title {
  color: #ffffff;
}

.App.dark-theme .server-count {
  color: #a0aec0;
}

.App.dark-theme .no-data {
  color: #a0aec0;
}

.App.dark-theme .loading {
  color: #e2e8f0;
}

.App.dark-theme .column-title h2 {
  color: #ffffff;
}

.App.dark-theme .view-toggle button:not(.active) {
  background-color: #2d3748;
  color: #a0aec0;
}

.App.dark-theme .pip-toggle-btn {
  background: #2d3748;
  border-color: #4a5568;
  color: #e2e8f0;
}

.App.dark-theme .pip-toggle-btn:hover {
  background: #4a5568;
  border-color: #718096;
}

/* Основний контейнер */
.app-container {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100vh;
}

/* Секції пулів */
.pool-section {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

.pool-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.pool-title {
  font-size: 24px;
  font-weight: 600;
  color: #2d3748;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
}

.server-count {
  font-size: 18px;
  color: #718096;
  font-weight: 500;
}

/* Картки серверів - ФІКСОВАНІ СТИЛІ */
.servers-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.server-card {
  position: relative;
  background: #ffffff;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
  height: 70px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  margin-bottom: 0;
}

/* Усі варіанти карток мають ОДНАКОВІ ФІКСОВАНІ розміри */
.server-card.completed {
  background-color: #c6f6d5;
  border-color: #48bb78;
  height: 70px;
}

.server-card.in-progress {
  background-color: #bee3f8;
  border-color: #4299e1;
  height: 70px;
}

.server-card.error {
  background-color: #fed7d7;
  border-color: #f56565;
  height: 70px;
}

.server-card.archived {
  background-color: #e2e8f0;
  border-color: #a0aec0;
  opacity: 0.7;
  height: 70px;
}

.server-content {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  padding: 12px;
  gap: 12px;
  width: 100%;
  height: 70px;
  box-sizing: border-box;
}

.server-info {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  height: 46px;
  justify-content: center;
  overflow: hidden;
}

.server-address {
  font-size: 16px;
  font-weight: 600;
  color: #2d3748;
  word-wrap: break-word;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  height: 20px;
  display: flex;
  align-items: center;
}

.server-status-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  height: 20px;
  overflow: hidden;
}

.server-status {
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  height: 20px;
  line-height: 1;
}

.server-status.success {
  color: #38a169;
}

.server-status.progress {
  color: #3182ce;
}

.server-status.error {
  color: #e53e3e;
}

.server-timer {
  font-size: 13px;
  font-weight: 600;
  color: #2d3748;
  white-space: nowrap;
  background-color: #ffd700;
  padding: 4px 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  height: 20px;
  flex-shrink: 0;
  line-height: 1;
}

.server-actions {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  height: 32px;
}

.detail-button {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #4299e1;
  color: white;
  border-radius: 4px;
  text-decoration: none;
  font-size: 18px;
  transition: background-color 0.2s;
  border: none;
  cursor: pointer;
  flex-shrink: 0;
}

.detail-button:hover {
  background-color: #3182ce;
}

.archive-button,
.unarchive-button {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: background-color 0.2s;
  white-space: nowrap;
  flex-shrink: 0;
  height: 32px;
  display: flex;
  align-items: center;
}

.archive-button {
  background-color: #ed8936;
  color: white;
}

.archive-button:hover {
  background-color: #dd771b;
}

.unarchive-button {
  background-color: #48bb78;
  color: white;
}

.unarchive-button:hover {
  background-color: #38a169;
}

/* Заголовок колонки */
.column-header {
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 15px;
}

.column-title h2 {
  margin: 0;
  color: #2d3748;
  font-size: 28px;
}

.column-actions {
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
}

.view-toggle {
  display: flex;
  gap: 10px;
}

.view-toggle button {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s;
  white-space: nowrap;
}

.view-toggle .active {
  background-color: #4299e1;
  color: white;
}

.view-toggle button:not(.active) {
  background-color: #e2e8f0;
  color: #4a5568;
}

/* Інші стилі */
.no-data {
  text-align: center;
  padding: 40px 20px;
  color: #718096;
  font-size: 16px;
}

.loading {
  text-align: center;
  padding: 40px 20px;
  font-size: 18px;
}

.error-message {
  background-color: #ffebee;
  color: #c62828;
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #ffcdd2;
}

/* PiP Controls - ФІКСОВАНА ПОЗИЦІЯ */
.pip-controls {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}

.pip-toggle-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.pip-toggle-btn:hover {
  background: #f8fafc;
  border-color: #cbd5e0;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.pool-header-left {
  display: flex;
  align-items: center;
}

.collapse-btn {
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
  padding: 5px;
}

/* Адаптивність */
@media (max-width: 768px) {
  .column-header {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .column-actions {
    width: 100%;
    justify-content: space-between;
  }
  
  .server-card {
    height: 70px;
  }
  
  .server-content {
    flex-wrap: wrap;
    height: 70px;
  }
  
  .server-actions {
    margin-top: 0;
    width: auto;
    justify-content: flex-end;
  }
  
  /* На мобільних кнопки приховуються */
  .server-actions .detail-button,
  .server-actions .archive-button,
  .server-actions .unarchive-button {
    display: none;
  }
  
  .server-status-row {
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }
  
  .pip-controls {
    bottom: 15px;
    right: 15px;
  }
  
  .pip-toggle-btn {
    padding: 6px 10px;
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .pool-section {
    padding: 15px;
  }
  
  .pool-title {
    font-size: 20px;
  }
  
  .server-address {
    font-size: 14px;
  }
  
  .server-card {
    height: 70px;
  }
  
  .pip-controls {
    bottom: 10px;
    right: 10px;
  }
}

/* Стилі для карток серверів */
.server-card.completed-with-errors {
  background-color: #fff3e0;
  border-left: 5px solid #ff9800;
  border: 1px solid #ffb74d;
}

.server-card.completed-with-errors:hover {
  background-color: #ffe0b2;
  box-shadow: 0 4px 8px rgba(255, 152, 0, 0.2);
}

/* Стиль для статусу */
.server-status.completed-with-errors {
  color: #ef6c00;
  background-color: #fff3e0;
  padding: 2px 8px;
  border-radius: 4px;
  border: 1px solid #ffb74d;
  font-weight: bold;
}

/* Для мобільних пристроїв */
@media (max-width: 768px) {
  .server-card.completed-with-errors {
    background-color: #fff3e0;
  }
}

.filters-section {
  background: white;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  border: 1px solid #e0e0e0;
}

.filters-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #f0f0f0;
}

.filters-header h3 {
  margin: 0;
  color: #333;
  font-size: 18px;
}

.reset-filters-btn {
  background: #f5f5f5;
  border: 1px solid #ddd;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  transition: all 0.2s;
}

.reset-filters-btn:hover {
  background: #e0e0e0;
  color: #333;
}

.filters-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.filter-group label {
  font-weight: 600;
  color: #555;
  font-size: 14px;
}

.filter-input, .filter-select {
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.filter-input:focus, .filter-select:focus {
  outline: none;
  border-color: #4d90fe;
  box-shadow: 0 0 0 2px rgba(77, 144, 254, 0.2);
}

.filter-stats {
  grid-column: 1 / -1;
  display: flex;
  gap: 30px;
  padding: 15px;
  background: #f9f9f9;
  border-radius: 4px;
  border: 1px solid #eee;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

.stat-label {
  font-size: 12px;
  color: #666;
}

.stat-value {
  font-size: 20px;
  font-weight: bold;
  color: #333;
}

.all-users-server-card.enhanced {
  border-left-width: 5px;
  transition: transform 0.2s, box-shadow 0.2s;
}

.all-users-server-card.enhanced:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.all-users-server-card.enhanced.dangerous {
  border-left-color: #f44336;
  background: linear-gradient(to right, #fff, #fff5f5);
}

.all-users-server-card.enhanced.dangerous .all-users-server-address {
  color: #d32f2f;
}

.dangerous-indicator {
  display: inline-block;
  background: #f44336;
  color: white;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
  margin-left: 10px;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.7; }
  100% { opacity: 1; }
}

.all-users-server-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin: 10px 0;
  font-size: 13px;
}

.meta-item {
  background: #f8f9fa;
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid #e9ecef;
}

.pool-description {
  color: #666;
  font-size: 14px;
  margin: 5px 0 0 0;
}

@media (max-width: 768px) {
  .filters-grid {
    grid-template-columns: 1fr;
  }
  
  .filter-stats {
    flex-direction: column;
    gap: 15px;
  }
  
  .all-users-server-meta {
    flex-direction: column;
    gap: 8px;
  }
}

/* Додайте ці стилі до Install.css */

.dangerous {
  border: 2px solid #dc3545 !important;
  background-color: #fff5f5 !important;
}

.dangerous-indicator {
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: #dc3545;
  color: white;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  z-index: 1;
}

.dangerous-tag {
  background-color: #dc3545;
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 11px;
  margin-left: 8px;
  font-weight: bold;
}

.dangerous-count {
  background-color: #dc3545;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  margin-left: 10px;
  font-weight: bold;
}

.process-controls {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
  flex-wrap: wrap;
}

.process-button {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.3s ease;
}

.full-process-btn {
  background-color: #28a745;
  color: white;
}

.full-process-btn:hover:not(:disabled) {
  background-color: #218838;
}

.compare-btn {
  background-color: #17a2b8;
  color: white;
}

.compare-btn:hover:not(:disabled) {
  background-color: #138496;
}

.process-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.search-filters {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 5px;
  margin-bottom: 15px;
  border: 1px solid #dee2e6;
}

.filter-row {
  display: flex;
  gap: 15px;
  align-items: center;
  flex-wrap: wrap;
}

.filter-group {
  flex: 1 1;
  min-width: 200px;
}

.search-input, .date-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #495057;
}

.checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.clear-filters-btn {
  padding: 8px 16px;
  background-color: #6c757d;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s ease;
}

.clear-filters-btn:hover {
  background-color: #5a6268;
}

.compare-result {
  margin-bottom: 15px;
  padding: 15px;
  background-color: #e7f3ff;
  border-left: 4px solid #007bff;
}

.compare-result h4 {
  margin-top: 0;
  margin-bottom: 10px;
  color: #0056b3;
}

.compare-result p {
  margin: 5px 0;
  font-size: 14px;
}

.column-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

.view-toggle {
  display: flex;
  gap: 5px;
}

@media (max-width: 768px) {
  .process-controls {
    flex-direction: column;
  }
  
  .filter-row {
    flex-direction: column;
  }
  
  .filter-group {
    min-width: 100%;
  }
  
  .clear-filters-btn {
    width: 100%;
  }
}

/* Стилі для темної теми - ДОДАТКОВІ */
.App.dark-theme .filters-section {
  background-color: #414752; /* Змінено для узгодження з пулами */
  border-color: #565d6a;
  box-shadow: 0 2px 10px rgba(0,0,0,0.3);
}

.App.dark-theme .filters-header {
  border-bottom-color: #565d6a;
}

.App.dark-theme .filters-header h3 {
  color: #ffffff;
}

.App.dark-theme .reset-filters-btn {
  background: #2d3748;
  border-color: #4a5568;
  color: #a0aec0;
}

.App.dark-theme .reset-filters-btn:hover {
  background: #4a5568;
  color: #ffffff;
}

.App.dark-theme .filter-group label {
  color: #a0aec0;
}

.App.dark-theme .filter-input,
.App.dark-theme .filter-select {
  background-color: #2d3748;
  border-color: #4a5568;
  color: #e2e8f0;
}

.App.dark-theme .filter-input:focus,
.App.dark-theme .filter-select:focus {
  border-color: #63b3ed;
  box-shadow: 0 0 0 2px rgba(99, 179, 237, 0.2);
}

.App.dark-theme .filter-stats {
  background: #2d3748;
  border-color: #4a5568;
}

.App.dark-theme .stat-label {
  color: #a0aec0;
}

.App.dark-theme .stat-value {
  color: #ffffff;
}

.App.dark-theme .all-users-server-card.enhanced.dangerous {
  background: linear-gradient(to right, #2d2d2d, #3a2d2d);
}

.App.dark-theme .meta-item {
  background: #2d3748;
  border-color: #4a5568;
  color: #a0aec0;
}

.App.dark-theme .pool-description {
  color: #a0aec0;
}

.App.dark-theme .dangerous {
  background-color: #3a2d2d !important;
}

.App.dark-theme .search-filters {
  background-color: #414752; /* Змінено для узгодження */
  border-color: #565d6a;
}

.App.dark-theme .search-input,
.App.dark-theme .date-input {
  background-color: #2d3748;
  border-color: #4a5568;
  color: #e2e8f0;
}

.App.dark-theme .checkbox-label {
  color: #a0aec0;
}

.App.dark-theme .clear-filters-btn {
  background-color: #4a5568;
}

.App.dark-theme .clear-filters-btn:hover {
  background-color: #718096;
}

.App.dark-theme .compare-result {
  background-color: #2d3c50;
  border-left-color: #3182ce;
}

.App.dark-theme .compare-result h4 {
  color: #63b3ed;
}

.App.dark-theme .compare-result p {
  color: #a0aec0;
}

.pip-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #282c34;
  color: white;
  position: sticky;
  top: 0;
  z-index: 100;
}

/* Стилі для PiP вікна в темній темі */
.pip-container.dark-theme .pip-header {
  background-color: #1a202c;
}

.pip-container.dark-theme {
  background-color: #1a202c;
  color: #e2e8f0;
}

.pip-container.dark-theme table {
  background-color: #2d3748;
}

.pip-container.dark-theme th {
  background-color: #414752;
  color: #ffffff;
  border-color: #565d6a;
}

.pip-container.dark-theme td {
  background-color: #2d3748;
  color: #e2e8f0;
  border-color: #4a5568;
}

.pip-container.dark-theme tr:nth-child(even) td {
  background-color: #2d3c50;
}

.pip-container.dark-theme tr:hover td {
  background-color: #4a5568;
}

.pip-container.dark-theme .download-button {
  background-color: #48bb78;
  color: white;
}

.pip-container.dark-theme .download-button:hover {
  background-color: #38a169;
}

.pip-container.dark-theme .exit-pip-button {
  background-color: #f56565;
  color: white;
}

.pip-container.dark-theme .exit-pip-button:hover {
  background-color: #e53e3e;
}

.pip-container.dark-theme .session-id {
  background: rgba(255,255,255,0.1);
  color: #a0aec0;
}

.pip-container.dark-theme .success-true {
  color: #68d391;
}

.pip-container.dark-theme .success-false {
  color: #fc8181;
}

.pip-container.dark-theme .error-message {
  color: #fc8181;
  background-color: rgba(252, 129, 129, 0.1);
  padding: 4px;
  border-radius: 3px;
}`, "",{"version":3,"sources":["webpack://./src/components/covfile/Install.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB,6CAA6C;AAC7C;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,uCAAuC;AACvC;EACE,yBAAyB,EAAE,iCAAiC;AAC9D;;AAEA;EACE,yBAAyB,EAAE,iCAAiC;EAC5D,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,yDAAyD;AACzD;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,iCAAiC;EACjC,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,aAAa;IACb,WAAW;IACX,yBAAyB;EAC3B;;EAEA,qCAAqC;EACrC;;;IAGE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA,sBAAsB;AACtB;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;EAC1B,oDAAoD;AACtD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,MAAM,YAAY,EAAE;EACpB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;AACF;;AAEA,oCAAoC;;AAEpC;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,sCAAsC;AACtC;EACE,yBAAyB,EAAE,oCAAoC;EAC/D,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB,EAAE,2BAA2B;EACtD,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA,sCAAsC;AACtC;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":["/* Install.css */\r\n/* Базові стилі для світлої теми (дефолтні) */\r\n.app-container {\r\n  padding: 20px;\r\n  background-color: #f5f5f5;\r\n  min-height: 100vh;\r\n}\r\n\r\n/* Стилі для темної теми - ТІЛЬКИ ФОН */\r\n.App.dark-theme .app-container {\r\n  background-color: #1a202c; /* Змінено з #121212 на #1a202c */\r\n}\r\n\r\n.App.dark-theme .pool-section {\r\n  background-color: #414752; /* Змінено з #1e1e1e на #414752 */\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.App.dark-theme .pool-title {\r\n  color: #ffffff;\r\n}\r\n\r\n.App.dark-theme .server-count {\r\n  color: #a0aec0;\r\n}\r\n\r\n.App.dark-theme .no-data {\r\n  color: #a0aec0;\r\n}\r\n\r\n.App.dark-theme .loading {\r\n  color: #e2e8f0;\r\n}\r\n\r\n.App.dark-theme .column-title h2 {\r\n  color: #ffffff;\r\n}\r\n\r\n.App.dark-theme .view-toggle button:not(.active) {\r\n  background-color: #2d3748;\r\n  color: #a0aec0;\r\n}\r\n\r\n.App.dark-theme .pip-toggle-btn {\r\n  background: #2d3748;\r\n  border-color: #4a5568;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.App.dark-theme .pip-toggle-btn:hover {\r\n  background: #4a5568;\r\n  border-color: #718096;\r\n}\r\n\r\n/* Основний контейнер */\r\n.app-container {\r\n  padding: 20px;\r\n  background-color: #f5f5f5;\r\n  min-height: 100vh;\r\n}\r\n\r\n/* Секції пулів */\r\n.pool-section {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 20px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  margin-bottom: 20px;\r\n  max-width: 1200px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.pool-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.pool-title {\r\n  font-size: 24px;\r\n  font-weight: 600;\r\n  color: #2d3748;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin: 0;\r\n}\r\n\r\n.server-count {\r\n  font-size: 18px;\r\n  color: #718096;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Картки серверів - ФІКСОВАНІ СТИЛІ */\r\n.servers-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.server-card {\r\n  position: relative;\r\n  background: #ffffff;\r\n  border: 2px solid #e2e8f0;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  transition: all 0.3s ease;\r\n  height: 70px;\r\n  display: flex;\r\n  align-items: center;\r\n  box-sizing: border-box;\r\n  margin-bottom: 0;\r\n}\r\n\r\n/* Усі варіанти карток мають ОДНАКОВІ ФІКСОВАНІ розміри */\r\n.server-card.completed {\r\n  background-color: #c6f6d5;\r\n  border-color: #48bb78;\r\n  height: 70px;\r\n}\r\n\r\n.server-card.in-progress {\r\n  background-color: #bee3f8;\r\n  border-color: #4299e1;\r\n  height: 70px;\r\n}\r\n\r\n.server-card.error {\r\n  background-color: #fed7d7;\r\n  border-color: #f56565;\r\n  height: 70px;\r\n}\r\n\r\n.server-card.archived {\r\n  background-color: #e2e8f0;\r\n  border-color: #a0aec0;\r\n  opacity: 0.7;\r\n  height: 70px;\r\n}\r\n\r\n.server-content {\r\n  position: relative;\r\n  z-index: 2;\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 12px;\r\n  gap: 12px;\r\n  width: 100%;\r\n  height: 70px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.server-info {\r\n  flex: 1;\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  height: 46px;\r\n  justify-content: center;\r\n  overflow: hidden;\r\n}\r\n\r\n.server-address {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: #2d3748;\r\n  word-wrap: break-word;\r\n  line-height: 1.2;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  max-width: 100%;\r\n  height: 20px;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.server-status-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  flex-wrap: nowrap;\r\n  height: 20px;\r\n  overflow: hidden;\r\n}\r\n\r\n.server-status {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  white-space: nowrap;\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  height: 20px;\r\n  line-height: 1;\r\n}\r\n\r\n.server-status.success {\r\n  color: #38a169;\r\n}\r\n\r\n.server-status.progress {\r\n  color: #3182ce;\r\n}\r\n\r\n.server-status.error {\r\n  color: #e53e3e;\r\n}\r\n\r\n.server-timer {\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: #2d3748;\r\n  white-space: nowrap;\r\n  background-color: #ffd700;\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  display: flex;\r\n  align-items: center;\r\n  height: 20px;\r\n  flex-shrink: 0;\r\n  line-height: 1;\r\n}\r\n\r\n.server-actions {\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  height: 32px;\r\n}\r\n\r\n.detail-button {\r\n  width: 32px;\r\n  height: 32px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background-color: #4299e1;\r\n  color: white;\r\n  border-radius: 4px;\r\n  text-decoration: none;\r\n  font-size: 18px;\r\n  transition: background-color 0.2s;\r\n  border: none;\r\n  cursor: pointer;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.detail-button:hover {\r\n  background-color: #3182ce;\r\n}\r\n\r\n.archive-button,\r\n.unarchive-button {\r\n  padding: 6px 12px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  transition: background-color 0.2s;\r\n  white-space: nowrap;\r\n  flex-shrink: 0;\r\n  height: 32px;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.archive-button {\r\n  background-color: #ed8936;\r\n  color: white;\r\n}\r\n\r\n.archive-button:hover {\r\n  background-color: #dd771b;\r\n}\r\n\r\n.unarchive-button {\r\n  background-color: #48bb78;\r\n  color: white;\r\n}\r\n\r\n.unarchive-button:hover {\r\n  background-color: #38a169;\r\n}\r\n\r\n/* Заголовок колонки */\r\n.column-header {\r\n  margin-top: 40px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 20px;\r\n  flex-wrap: wrap;\r\n  gap: 15px;\r\n}\r\n\r\n.column-title h2 {\r\n  margin: 0;\r\n  color: #2d3748;\r\n  font-size: 28px;\r\n}\r\n\r\n.column-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 15px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.view-toggle {\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n.view-toggle button {\r\n  padding: 8px 16px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-weight: 500;\r\n  transition: all 0.2s;\r\n  white-space: nowrap;\r\n}\r\n\r\n.view-toggle .active {\r\n  background-color: #4299e1;\r\n  color: white;\r\n}\r\n\r\n.view-toggle button:not(.active) {\r\n  background-color: #e2e8f0;\r\n  color: #4a5568;\r\n}\r\n\r\n/* Інші стилі */\r\n.no-data {\r\n  text-align: center;\r\n  padding: 40px 20px;\r\n  color: #718096;\r\n  font-size: 16px;\r\n}\r\n\r\n.loading {\r\n  text-align: center;\r\n  padding: 40px 20px;\r\n  font-size: 18px;\r\n}\r\n\r\n.error-message {\r\n  background-color: #ffebee;\r\n  color: #c62828;\r\n  padding: 10px;\r\n  margin: 10px 0;\r\n  border-radius: 4px;\r\n  border: 1px solid #ffcdd2;\r\n}\r\n\r\n/* PiP Controls - ФІКСОВАНА ПОЗИЦІЯ */\r\n.pip-controls {\r\n  position: fixed;\r\n  bottom: 20px;\r\n  right: 20px;\r\n  z-index: 1000;\r\n}\r\n\r\n.pip-toggle-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  background: white;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 6px;\r\n  padding: 8px 12px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  transition: all 0.2s ease;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.pip-toggle-btn:hover {\r\n  background: #f8fafc;\r\n  border-color: #cbd5e0;\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.pool-header-left {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.collapse-btn {\r\n  background: none;\r\n  border: none;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n  padding: 5px;\r\n}\r\n\r\n/* Адаптивність */\r\n@media (max-width: 768px) {\r\n  .column-header {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n  \r\n  .column-actions {\r\n    width: 100%;\r\n    justify-content: space-between;\r\n  }\r\n  \r\n  .server-card {\r\n    height: 70px;\r\n  }\r\n  \r\n  .server-content {\r\n    flex-wrap: wrap;\r\n    height: 70px;\r\n  }\r\n  \r\n  .server-actions {\r\n    margin-top: 0;\r\n    width: auto;\r\n    justify-content: flex-end;\r\n  }\r\n  \r\n  /* На мобільних кнопки приховуються */\r\n  .server-actions .detail-button,\r\n  .server-actions .archive-button,\r\n  .server-actions .unarchive-button {\r\n    display: none;\r\n  }\r\n  \r\n  .server-status-row {\r\n    flex-direction: row;\r\n    align-items: center;\r\n    gap: 8px;\r\n  }\r\n  \r\n  .pip-controls {\r\n    bottom: 15px;\r\n    right: 15px;\r\n  }\r\n  \r\n  .pip-toggle-btn {\r\n    padding: 6px 10px;\r\n    font-size: 12px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .pool-section {\r\n    padding: 15px;\r\n  }\r\n  \r\n  .pool-title {\r\n    font-size: 20px;\r\n  }\r\n  \r\n  .server-address {\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .server-card {\r\n    height: 70px;\r\n  }\r\n  \r\n  .pip-controls {\r\n    bottom: 10px;\r\n    right: 10px;\r\n  }\r\n}\r\n\r\n/* Стилі для карток серверів */\r\n.server-card.completed-with-errors {\r\n  background-color: #fff3e0;\r\n  border-left: 5px solid #ff9800;\r\n  border: 1px solid #ffb74d;\r\n}\r\n\r\n.server-card.completed-with-errors:hover {\r\n  background-color: #ffe0b2;\r\n  box-shadow: 0 4px 8px rgba(255, 152, 0, 0.2);\r\n}\r\n\r\n/* Стиль для статусу */\r\n.server-status.completed-with-errors {\r\n  color: #ef6c00;\r\n  background-color: #fff3e0;\r\n  padding: 2px 8px;\r\n  border-radius: 4px;\r\n  border: 1px solid #ffb74d;\r\n  font-weight: bold;\r\n}\r\n\r\n/* Для мобільних пристроїв */\r\n@media (max-width: 768px) {\r\n  .server-card.completed-with-errors {\r\n    background-color: #fff3e0;\r\n  }\r\n}\r\n\r\n.filters-section {\r\n  background: white;\r\n  border-radius: 8px;\r\n  padding: 20px;\r\n  margin-bottom: 20px;\r\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\r\n  border: 1px solid #e0e0e0;\r\n}\r\n\r\n.filters-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 20px;\r\n  padding-bottom: 15px;\r\n  border-bottom: 2px solid #f0f0f0;\r\n}\r\n\r\n.filters-header h3 {\r\n  margin: 0;\r\n  color: #333;\r\n  font-size: 18px;\r\n}\r\n\r\n.reset-filters-btn {\r\n  background: #f5f5f5;\r\n  border: 1px solid #ddd;\r\n  padding: 8px 16px;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  color: #666;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.reset-filters-btn:hover {\r\n  background: #e0e0e0;\r\n  color: #333;\r\n}\r\n\r\n.filters-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\r\n  gap: 20px;\r\n}\r\n\r\n.filter-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.filter-group label {\r\n  font-weight: 600;\r\n  color: #555;\r\n  font-size: 14px;\r\n}\r\n\r\n.filter-input, .filter-select {\r\n  padding: 10px 12px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  transition: border-color 0.2s;\r\n}\r\n\r\n.filter-input:focus, .filter-select:focus {\r\n  outline: none;\r\n  border-color: #4d90fe;\r\n  box-shadow: 0 0 0 2px rgba(77, 144, 254, 0.2);\r\n}\r\n\r\n.filter-stats {\r\n  grid-column: 1 / -1;\r\n  display: flex;\r\n  gap: 30px;\r\n  padding: 15px;\r\n  background: #f9f9f9;\r\n  border-radius: 4px;\r\n  border: 1px solid #eee;\r\n}\r\n\r\n.stat-item {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 5px;\r\n}\r\n\r\n.stat-label {\r\n  font-size: 12px;\r\n  color: #666;\r\n}\r\n\r\n.stat-value {\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n  color: #333;\r\n}\r\n\r\n.all-users-server-card.enhanced {\r\n  border-left-width: 5px;\r\n  transition: transform 0.2s, box-shadow 0.2s;\r\n}\r\n\r\n.all-users-server-card.enhanced:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\r\n}\r\n\r\n.all-users-server-card.enhanced.dangerous {\r\n  border-left-color: #f44336;\r\n  background: linear-gradient(to right, #fff, #fff5f5);\r\n}\r\n\r\n.all-users-server-card.enhanced.dangerous .all-users-server-address {\r\n  color: #d32f2f;\r\n}\r\n\r\n.dangerous-indicator {\r\n  display: inline-block;\r\n  background: #f44336;\r\n  color: white;\r\n  padding: 2px 8px;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  font-weight: bold;\r\n  margin-left: 10px;\r\n  animation: pulse 2s infinite;\r\n}\r\n\r\n@keyframes pulse {\r\n  0% { opacity: 1; }\r\n  50% { opacity: 0.7; }\r\n  100% { opacity: 1; }\r\n}\r\n\r\n.all-users-server-meta {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 15px;\r\n  margin: 10px 0;\r\n  font-size: 13px;\r\n}\r\n\r\n.meta-item {\r\n  background: #f8f9fa;\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  border: 1px solid #e9ecef;\r\n}\r\n\r\n.pool-description {\r\n  color: #666;\r\n  font-size: 14px;\r\n  margin: 5px 0 0 0;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .filters-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  \r\n  .filter-stats {\r\n    flex-direction: column;\r\n    gap: 15px;\r\n  }\r\n  \r\n  .all-users-server-meta {\r\n    flex-direction: column;\r\n    gap: 8px;\r\n  }\r\n}\r\n\r\n/* Додайте ці стилі до Install.css */\r\n\r\n.dangerous {\r\n  border: 2px solid #dc3545 !important;\r\n  background-color: #fff5f5 !important;\r\n}\r\n\r\n.dangerous-indicator {\r\n  position: absolute;\r\n  top: 5px;\r\n  right: 5px;\r\n  background-color: #dc3545;\r\n  color: white;\r\n  border-radius: 50%;\r\n  width: 24px;\r\n  height: 24px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 14px;\r\n  z-index: 1;\r\n}\r\n\r\n.dangerous-tag {\r\n  background-color: #dc3545;\r\n  color: white;\r\n  padding: 2px 6px;\r\n  border-radius: 4px;\r\n  font-size: 11px;\r\n  margin-left: 8px;\r\n  font-weight: bold;\r\n}\r\n\r\n.dangerous-count {\r\n  background-color: #dc3545;\r\n  color: white;\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  margin-left: 10px;\r\n  font-weight: bold;\r\n}\r\n\r\n.process-controls {\r\n  display: flex;\r\n  gap: 10px;\r\n  margin-bottom: 15px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.process-button {\r\n  padding: 8px 16px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-weight: bold;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.full-process-btn {\r\n  background-color: #28a745;\r\n  color: white;\r\n}\r\n\r\n.full-process-btn:hover:not(:disabled) {\r\n  background-color: #218838;\r\n}\r\n\r\n.compare-btn {\r\n  background-color: #17a2b8;\r\n  color: white;\r\n}\r\n\r\n.compare-btn:hover:not(:disabled) {\r\n  background-color: #138496;\r\n}\r\n\r\n.process-button:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.search-filters {\r\n  background-color: #f8f9fa;\r\n  padding: 15px;\r\n  border-radius: 5px;\r\n  margin-bottom: 15px;\r\n  border: 1px solid #dee2e6;\r\n}\r\n\r\n.filter-row {\r\n  display: flex;\r\n  gap: 15px;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.filter-group {\r\n  flex: 1;\r\n  min-width: 200px;\r\n}\r\n\r\n.search-input, .date-input {\r\n  width: 100%;\r\n  padding: 8px 12px;\r\n  border: 1px solid #ced4da;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n}\r\n\r\n.checkbox-label {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  color: #495057;\r\n}\r\n\r\n.checkbox-label input[type=\"checkbox\"] {\r\n  width: 18px;\r\n  height: 18px;\r\n  cursor: pointer;\r\n}\r\n\r\n.clear-filters-btn {\r\n  padding: 8px 16px;\r\n  background-color: #6c757d;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.clear-filters-btn:hover {\r\n  background-color: #5a6268;\r\n}\r\n\r\n.compare-result {\r\n  margin-bottom: 15px;\r\n  padding: 15px;\r\n  background-color: #e7f3ff;\r\n  border-left: 4px solid #007bff;\r\n}\r\n\r\n.compare-result h4 {\r\n  margin-top: 0;\r\n  margin-bottom: 10px;\r\n  color: #0056b3;\r\n}\r\n\r\n.compare-result p {\r\n  margin: 5px 0;\r\n  font-size: 14px;\r\n}\r\n\r\n.column-actions {\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: center;\r\n}\r\n\r\n.view-toggle {\r\n  display: flex;\r\n  gap: 5px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .process-controls {\r\n    flex-direction: column;\r\n  }\r\n  \r\n  .filter-row {\r\n    flex-direction: column;\r\n  }\r\n  \r\n  .filter-group {\r\n    min-width: 100%;\r\n  }\r\n  \r\n  .clear-filters-btn {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n/* Стилі для темної теми - ДОДАТКОВІ */\r\n.App.dark-theme .filters-section {\r\n  background-color: #414752; /* Змінено для узгодження з пулами */\r\n  border-color: #565d6a;\r\n  box-shadow: 0 2px 10px rgba(0,0,0,0.3);\r\n}\r\n\r\n.App.dark-theme .filters-header {\r\n  border-bottom-color: #565d6a;\r\n}\r\n\r\n.App.dark-theme .filters-header h3 {\r\n  color: #ffffff;\r\n}\r\n\r\n.App.dark-theme .reset-filters-btn {\r\n  background: #2d3748;\r\n  border-color: #4a5568;\r\n  color: #a0aec0;\r\n}\r\n\r\n.App.dark-theme .reset-filters-btn:hover {\r\n  background: #4a5568;\r\n  color: #ffffff;\r\n}\r\n\r\n.App.dark-theme .filter-group label {\r\n  color: #a0aec0;\r\n}\r\n\r\n.App.dark-theme .filter-input,\r\n.App.dark-theme .filter-select {\r\n  background-color: #2d3748;\r\n  border-color: #4a5568;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.App.dark-theme .filter-input:focus,\r\n.App.dark-theme .filter-select:focus {\r\n  border-color: #63b3ed;\r\n  box-shadow: 0 0 0 2px rgba(99, 179, 237, 0.2);\r\n}\r\n\r\n.App.dark-theme .filter-stats {\r\n  background: #2d3748;\r\n  border-color: #4a5568;\r\n}\r\n\r\n.App.dark-theme .stat-label {\r\n  color: #a0aec0;\r\n}\r\n\r\n.App.dark-theme .stat-value {\r\n  color: #ffffff;\r\n}\r\n\r\n.App.dark-theme .all-users-server-card.enhanced.dangerous {\r\n  background: linear-gradient(to right, #2d2d2d, #3a2d2d);\r\n}\r\n\r\n.App.dark-theme .meta-item {\r\n  background: #2d3748;\r\n  border-color: #4a5568;\r\n  color: #a0aec0;\r\n}\r\n\r\n.App.dark-theme .pool-description {\r\n  color: #a0aec0;\r\n}\r\n\r\n.App.dark-theme .dangerous {\r\n  background-color: #3a2d2d !important;\r\n}\r\n\r\n.App.dark-theme .search-filters {\r\n  background-color: #414752; /* Змінено для узгодження */\r\n  border-color: #565d6a;\r\n}\r\n\r\n.App.dark-theme .search-input,\r\n.App.dark-theme .date-input {\r\n  background-color: #2d3748;\r\n  border-color: #4a5568;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.App.dark-theme .checkbox-label {\r\n  color: #a0aec0;\r\n}\r\n\r\n.App.dark-theme .clear-filters-btn {\r\n  background-color: #4a5568;\r\n}\r\n\r\n.App.dark-theme .clear-filters-btn:hover {\r\n  background-color: #718096;\r\n}\r\n\r\n.App.dark-theme .compare-result {\r\n  background-color: #2d3c50;\r\n  border-left-color: #3182ce;\r\n}\r\n\r\n.App.dark-theme .compare-result h4 {\r\n  color: #63b3ed;\r\n}\r\n\r\n.App.dark-theme .compare-result p {\r\n  color: #a0aec0;\r\n}\r\n\r\n.pip-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 10px;\r\n  background-color: #282c34;\r\n  color: white;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 100;\r\n}\r\n\r\n/* Стилі для PiP вікна в темній темі */\r\n.pip-container.dark-theme .pip-header {\r\n  background-color: #1a202c;\r\n}\r\n\r\n.pip-container.dark-theme {\r\n  background-color: #1a202c;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.pip-container.dark-theme table {\r\n  background-color: #2d3748;\r\n}\r\n\r\n.pip-container.dark-theme th {\r\n  background-color: #414752;\r\n  color: #ffffff;\r\n  border-color: #565d6a;\r\n}\r\n\r\n.pip-container.dark-theme td {\r\n  background-color: #2d3748;\r\n  color: #e2e8f0;\r\n  border-color: #4a5568;\r\n}\r\n\r\n.pip-container.dark-theme tr:nth-child(even) td {\r\n  background-color: #2d3c50;\r\n}\r\n\r\n.pip-container.dark-theme tr:hover td {\r\n  background-color: #4a5568;\r\n}\r\n\r\n.pip-container.dark-theme .download-button {\r\n  background-color: #48bb78;\r\n  color: white;\r\n}\r\n\r\n.pip-container.dark-theme .download-button:hover {\r\n  background-color: #38a169;\r\n}\r\n\r\n.pip-container.dark-theme .exit-pip-button {\r\n  background-color: #f56565;\r\n  color: white;\r\n}\r\n\r\n.pip-container.dark-theme .exit-pip-button:hover {\r\n  background-color: #e53e3e;\r\n}\r\n\r\n.pip-container.dark-theme .session-id {\r\n  background: rgba(255,255,255,0.1);\r\n  color: #a0aec0;\r\n}\r\n\r\n.pip-container.dark-theme .success-true {\r\n  color: #68d391;\r\n}\r\n\r\n.pip-container.dark-theme .success-false {\r\n  color: #fc8181;\r\n}\r\n\r\n.pip-container.dark-theme .error-message {\r\n  color: #fc8181;\r\n  background-color: rgba(252, 129, 129, 0.1);\r\n  padding: 4px;\r\n  border-radius: 3px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
